import { h } from 'preact';
import Card from 'preact-material-components/Card';
import 'preact-material-components/Card/style.css';

import style from './style';

export default class DisplayCard extends Card {
	render() {
		return (
			<Card class={style.displayCard}>

				{
					this.props.header
						?
						<div class={style.cardHeader}>
							<h2>{this.props.header}</h2>
						</div>
						:
						null
				}

				<div class={style.cardBody}>
					{this.props.children}
				</div>

			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./components/DisplayCard/index.js